
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import "./BNPLPage.css";


import {

  Link
} from "react-router-dom";


import React from "react";
function BNPLPage(){
    return(<div className="container py-5 text-center" style={{ maxWidth: "1090px", margin: "0 auto" , fontFamily:  'Plus Jakarta Sans'}}>
      
      <img src="/bnpl.webp" className="img-fluid-rounded-shadow" alt="Changer product page" />
      <style>{`
    .img-fluid-rounded-shadow {
      maxWidth: 1102px;
      height: 489px;
      display: block;
      margin: 0 auto;
      opacity: 0;
      transform: translateY(30px);
      animation: fadeInUp 1s ease-out forwards;
      animation-delay: 0.3s;
    }
  
    @keyframes fadeInUp {
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `}</style>
      <h2 className="animated-text mt-5" style={{ color: "#fff", fontSize: "24px", lineHeight: "%140"}}>
      Connect your customers to multiple lenders through one simple integration.<br />
      <strong>Offer competitive financing effortlessly and boost sales.</strong>
    </h2>
     <br></br>
    <p className="animated-text mt-4" style={{ maxWidth: "900px", margin: "0 auto", fontSize: "18px", lineHeight: "28px" }}>
      Partner with Taksit-le and transform your checkout experience. Our platform acts as your single gateway to multiple trusted lenders, 
      enabling you to offer flexible ‘Buy Now, Pay Later’ options without the typical integration headaches or administrative burden. 
      Provide competitive financing choices effortlessly, reduce cart abandonment, and watch your sales climb. 
      We manage the complexities of credit checks and loan servicing while guaranteeing you receive full payment upfront. 
      Give your business a competitive edge and empower customers to purchase more, more often.
    </p>
    <style>{`
      .animated-text {
        opacity: 0;
        transform: translateY(20px);
        animation: fadeInText 1.2s ease-out forwards;
        animation-delay: 0.5s;
      }
  
      @keyframes fadeInText {
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `}</style>
    <br></br>
    <hr
    style={{
      border: "none",
      borderTop: "1px solid #fff",
      marginTop: "40px",
      width: "1070px",
      margin: "40px auto 0 auto"
    }}
  />
  
      <br>
    </br>
     <p25>Integrating & Selling with Taksit-le is Simple</p25>
     <br></br>
     <p26>Offer powerful financing options in just a few steps, while we manage the complexity. </p26>
     <br></br>
     <br></br>
     <div 
    className="info-box px-4 py-3 mt-4 mx-auto" 
    style={{
      borderRadius: "0.5rem",
      maxWidth: "900px",
      textAlign: "center",
      fontSize: "18px",
      lineHeight: "1.6",
      backgroundColor: "transparent",
  
    }}
  >
    Connect Taksit-le to your online store or POS system quickly using our straightforward APIs or pre-built
    plugins for popular e-commerce platforms. Taksit-le automatically appears as a payment option during your 
    customer's checkout process. They see clear, affordable installment plans tailored to their purchase. 
    Once the customer is approved (which happens in seconds), you receive the full purchase amount directly 
    from us, typically within 1–2 business days.
  </div>
  
  <div style={{ display: "flex", justifyContent: "center" }}>
      <section className="section row"  style={{ maxWidth: "1070px", width: "100%"  }}>
    {[
      {
        title: "Seamless Setup",
        text: "Getting started with Taksit-le is hassle-free. Our flexible integration options (APIs & plugins) allow you to add powerful financing capabilities to your existing checkout flow with minimal disruption or development effort.",
        icon: <img src="18.webp" alt="icon" className="card-icon" />,
        background: `radial-gradient(circle at top left, #EA4436, transparent 45%),#1C2126`
      },
      {
        title: "Enhanced Customer Experience",
        text: "At checkout, customers see flexible installment plans powered by Taksit-le. They apply in moments through our secure portal, connecting to multiple lenders to  approve and ease purchases.",
        icon: <img src="19.webp" alt="icon" className="card-icon" />,
        background: `radial-gradient(circle at top center, #C43B8D, transparent 60%),#1C2126`
      },
      {
        title: "Effortless & Risk-Free Payments",
        text: " We manage the entire lending process, from application to ongoing collections. Most importantly, you receive the full payment for the order upfront from Taksit-le, eliminating any credit risk or delays for your business.",
        icon: <img src="20.webp" alt="icon" className="card-icon" />,
        background: `radial-gradient(circle at top right, #07A5DF, transparent 45%),#1C2126`
      }
    ].map((item, i) => (
      <div className="col-md-4 mb-4" key={i}>
        <div
          className="p-4 h-100 text-white shadow-lg true-style-card position-relative"
          style={{
            background: item.background,
            borderRadius: "1rem"
          }}
        >
          <div className="icon-visible text-start mb-3">
            {item.icon}
          </div>
          <h5 className="card-title text-start">{item.title}</h5>
          <p className="card-text text-start">{item.text}</p>
        </div>
      </div>
    ))}
  </section>
  </div>
  <style>{`
    .card-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 0.5rem;
    }
  
    .card-text {
      font-size: 14px;
      color: #ccc;
    }
  
    .card-icon {
      width: 24px;
      height: 24px;
    }
  `}</style>
   <hr
    style={{
      border: "none",
      borderTop: "1px solid #fff",
      marginTop: "40px",
      width: "1070px",
      margin: "40px auto 0 auto"
    }}
  />
  
   
   <section className="key-advantages-section px-4 py-5 text-white" >
   <div className="mb-4 key-advantages-header-area" style={{ textAlign: "left" }}>
    <h2 className="fw-bold" style={{ fontSize: "36px" }}>Key Advantages</h2>
    <p
      style={{
        color: "#9EABB8",
        maxWidth: "800px",
        fontSize: "16px", 
        
      }}
    >
      We provide tailored digital solutions across key areas to help telecom and banking institutions achieve their strategic goals.
    </p>
  </div>
  
    {/* Üstteki 4 kutu */}
    <div 
    className="d-flex flex-wrap justify-content-center gap-4 mb-5"
    style={{ maxWidth: "1090px", margin: "0 auto", gap: "10px" }}
  >
    {[
      {
        title: "Boost Sales & Conversion Rates",
        text: "Make higher-priced items more accessible and reduce checkout friction. By offering affordable installments, you empower customers to buy now, significantly reducing cart abandonment and increasing overall sales.",
        icon: <img src="35.webp" alt="icon" className="card-icon" />
      },
      {
        title: "Increase Average Order Value (AOV)",
        text: "Customers are more likely to purchase higher-value items or add more to their cart when flexible payment options are available. Taksit-le makes bigger baskets more affordable.",
        icon: <img src="34.webp" alt="icon" className="card-icon" />
      },
      {
        title: "Receive Guaranteed Upfront Payments",
        text: "Eliminate cash flow uncertainty. You get paid the full purchase amount quickly and upfront, regardless of the customer's repayment schedule. We handle the collections process.",
        icon: <img src="33.webp" alt="icon" className="card-icon" />
      },
      {
        title: "Zero Credit & Fraud Risk for You",
        text: "Offer financing without the liability. Taksit-le and our lending partners assume all the risk associated with customer non-payment or fraud. Your revenue is protected.",
        icon: <img src="32.webp" alt="icon" className="card-icon" />
      }
    ].map((item, i) => (
      <div 
        key={i} 
        style={{ 
          padding: "1px",
          borderRadius: "10px",
          background: "linear-gradient(360deg, #879EBA 0%, #3E3E3E 50%, #879EBA 100%)",
          width: "236px", 
          height: window.innerWidth > 768 ? "296px" : "auto",
          transition: "transform 0.3s", 
          cursor: "pointer" 
        }} 
        className="hover-box"
      >
        <div style={{
          backgroundColor: "#1C2126",
          borderRadius: "10px",
          border: "1px solid #2A2A2A",
          padding: "1rem",
          height: "100%",
          textAlign: "center"
        }}>
          <div style={{ fontSize: "24px", marginBottom: "12px" }}>{item.icon}</div>
          <h5 style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "4px" }}>{item.title}</h5>
          <p style={{ fontSize: "14px", color: "#9EABB8" }}>{item.text}</p>
        </div>
      </div>
    ))}
  </div>
  
  
    {/* Alttaki 2 kutu */}
    <div className="alt-kutu d-flex justify-content-center gap-4" style={{ maxWidth: "1070px", margin: "0 auto", maxHeight: "171px" }}>
      {[
        {
          title: "Access Multiple Lenders, Maximize Approvals",
          text: "Our multi-lender platform increases the likelihood of customer approval compared to single-lender solutions. More approved customers mean more completed sales for you.",
          icon: <img src="31.webp" alt="icon" className="card-icon" />
        },
        {
          title: "Simple Integration & Management",
          text: "Get up and running quickly with our easy-to-use APIs and plugins. Manage everything through one platform, minimizing technical overhead and administrative burden.",
          icon: <img src="30.webp" alt="icon" className="card-icon5" />
        }
      ].map((item, i) => (
        <div key={i} style={{
          padding: "1px",
          borderRadius: "10px",
         background: "linear-gradient(180deg, #879EBA 0%, #3E3E3E 50%, #879EBA 100%)", maxWidth: "525px", transition: "transform 0.3s", cursor: "pointer" }} className="hover-box">
          <div style={{
            backgroundColor: "#1C2126",
            borderRadius: "12px",
            border: "1px solid #2A2A2A",
            padding: "1rem",
            height: "100%",
            textAlign: "center"
          }}>
            <div style={{ fontSize: "24px", marginBottom: "12px" }}>{item.icon}</div>
            <h5 style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "8px" }}>{item.title}</h5>
            <p style={{ fontSize: "14px", color: "#9EABB8" }}>{item.text}</p>
          </div>
        </div>
      ))}
    </div>
  
    {/* Hover animasyonu için stil */}
    <style jsx>{`
      .hover-box:hover {
        transform: translateY(-5px);
      }
    `}</style>
  </section>
  <hr
    style={{
      
      borderTop: "1px solid #fff",
      marginTop: "20px",
      width: "1070px",
      margin: "40px auto 0 auto"
    }}
  />
  <br></br> <br></br><section className="bnpl-cta-section w-full flex justify-start items-center py-10 px-4">
    <div
      className="changerlast relative rounded-[12px] overflow-hidden flex items-center ml-0"
      style={{
        backgroundImage: "url('/changerlast.webp')", 
        backgroundSize: "cover",
        backgroundPosition: "center",
        paddingTop: "16px",
        paddingBottom: "16px",
        borderRadius: "20px",
        maxWidth: "1070px",
        height: "512px",
        display: "flex",
        margin: "0 auto",
        color: "#fff",
        
        alignItems: "center",
        justifyContent : "center"
      }}
    >
      <div
        className="text-white px-10 max-w-[600px]"
        style={{
          maxWidth: "848px",
          borderRadius: "40px",
          padding: "40px",
          backgroundColor: "rgba(255, 255, 255, 0.01)",
          backdropFilter: "blur(1px)",
          WebkitBackdropFilter: "blur(2px)",
          color: "#fff",
          textAlign: "left",
        }}
      >
        <h1
          className="ready-to-boost text-4xl font-bold mb-6"
          style={{
            fontWeight: "700",
            fontSize: "48px",
            lineHeight: "60px",
            letterSpacing: "-2px",
          }}
        >
          Ready to Boost Your Sales?
        </h1>
  
        <p
          className="text-base leading-relaxed mb-6"
          style={{
            fontWeight: "400",
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: "0px",
            color: "#fff",
          }}
        >
          Let us show you how Taksit-less simple integration drives higher
          conversion rates and average order values, risk-free. Get a
          personalized demo with our partnership team to see the platform in
          action and learn about guaranteed upfront payments. Schedule your demo
          now.
        </p>
        <div className="request-demo">
        <Link to="/contactus" onClick={() => window.scrollTo(0, 0)}>
        <button
          style={{
            maxWidth: "175px",
            maxHeight: "48px",
            backgroundColor: "#2563eb",
            color: "#fff",
            padding: "12px 24px",
            border: "none",
            borderRadius: "20px",
            fontSize: "14px",
            fontWeight: "500",
            cursor: "pointer",
          }}
        >
          Request a demo
        </button>
        </Link>
        </div>
      </div>
    </div>
  </section>
  
  
    </div>
   
    );
  }
  export default BNPLPage;